module.exports = __webpack_public_path__ + "media/images/icons/User,Profile.12-57e125f99b80cdbc6ba8cf4f95a8320b.svg";